import { render } from "./Search.vue?vue&type=template&id=18760e64&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=18760e64&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18760e64"],['__file',"src/views/home/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18760e64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18760e64', __exports__)) {
    console.log('reload')
    api.reload('18760e64', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=18760e64&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('18760e64', render)
  })

}


export default __exports__